import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, Subject } from 'rxjs';
import { API_BASE_URL } from "@shared/service-proxies/service-proxies";


@Injectable()
export class ApiFilesService {
    private http: HttpClient;
    private baseUrl: string;
    private loadingSubject = new Subject<boolean>();
    loading$: Observable<boolean> = this.loadingSubject.asObservable();

    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Optional() @Inject(API_BASE_URL) baseUrl?: string
    ) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }


    public downloadInvoiceXml(invoiceId: string): Observable<void> {
        return this.http.get(`${this.baseUrl}/api/file/DownloadInvoiceXml`, {
            params: { invoiceId },
            responseType: 'blob',
            observe: 'response',
        }).pipe(
            map((response) => {
                if (response.status === 200) {
                    const contentDisposition = response.headers.get('Content-Disposition');
                    const fileName = this.extractFileName(contentDisposition) || 'invoice.xml';

                    const url = window.URL.createObjectURL(new Blob([response.body]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url); // Clean up the object URL
                } else {
                    console.error('Failed to download file. Status:', response.status);
                }
            }),
            catchError((error) => {
                console.error('Error downloading the file', error);
                throw error; // You can also throw a custom error here if needed
            })
        );
    }

    private extractFileName(contentDisposition: string | null): string | undefined {
        if (!contentDisposition) return undefined;

        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        return fileNameMatch ? fileNameMatch[1] : undefined;
    }
}
